export default __webpack_public_path__ + "static/media/Levitate D7.1 Defining the future of freight transport.61789b99.pdf";